import { render } from "./DashboardPendingEntryOrders.vue?vue&type=template&id=51675606&scoped=true&ts=true"
import script from "./DashboardPendingEntryOrders.vue?vue&type=script&lang=ts"
export * from "./DashboardPendingEntryOrders.vue?vue&type=script&lang=ts"

import "./DashboardPendingEntryOrders.vue?vue&type=style&index=0&id=51675606&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51675606"]])

export default __exports__